import { createApiHook } from '../hooks';
import { creativesLibraryApiFactory } from './creativesLibraryApiFactory';

export const useCreativesLibraryApi = createApiHook(creativesLibraryApiFactory);
